













































































import Vue from 'vue';

import { ArquivoKeyEnum } from '@/utils/constants/back.constants';
import { maximumFractionDigitsCurrency } from '@/utils/intl-functions';
import { getPaisCurrency, getPaisLocale } from '@/utils/pais-helper';

export default Vue.extend({
  name: 'CatalisadoresCatalogoCard',
  props: {
    catalisadorPeca: {
      type: Object,
      required: true,
    },
    hoverable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    locale() {
      return getPaisLocale();
    },
    currency() {
      return getPaisCurrency();
    },
  },
  methods: {
    maximumFractionDigitsCurrency,
    getFotoArquivoSrc(catalisadorPeca) {
      const path = catalisadorPeca?.fotoArquivo?.path;
      if (!path) return null;
      return `${process.env.VUE_APP_URL_API}${path}/${ArquivoKeyEnum.WATERMARK}`;
    },
  },
});
